import React from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    LabelList,
    ResponsiveContainer
} from "recharts";
import { DEPARTMENT_COLORS, DEFAULT_COLOR } from "../../utils/departmentColors";

const transformData = (data) => {
    const result = {};

    data.forEach(item => {
        const month = new Date(item.month).toLocaleDateString("en-IN", {
            month: "short",
            year: "numeric"
        });

        if (!result[month]) {
            result[month] = { month, total: 0 };
        }

        const value = Number(item.count);

        result[month][item.Department] = value;
        result[month].total += value; // ✅ store total
    });

    return Object.values(result);
};

const PlacedChart = ({ data }) => {
    const chartData = transformData(data);

    const total = data.reduce((sum, item) => sum + Number(item.count), 0);

    const departments = Object.entries(
        data.reduce((acc, item) => {
            acc[item.Department] = (acc[item.Department] || 0) + Number(item.count);
            return acc;
        }, {})
    )
        .sort((a, b) => b[1] - a[1])
        .map(([dep]) => dep);

    const renderTotalLabel = (props) => {
        const { x, y, width, height, value } = props;

        if (value === 0) return null;

        return (
            <text
                x={x + width / 2}
                y={y - 5}  // ✅ small offset instead of 10
                textAnchor="middle"
                dominantBaseline="middle" // ✅ important for vertical alignment
                fontSize={12}
                fill="#000"
            >
                {value}
            </text>
        );
    };
    const CustomTooltip = ({ active, payload, label }) => {
        if (!active || !payload || !payload.length) return null;

        const data = payload[0]?.payload;
        if (!data) return null;

        const deptData = Object.keys(data)
            .filter(key => key !== "month" && key !== "total")
            .map(key => ({
                name: key,
                value: data[key],
                color: DEPARTMENT_COLORS[key] || DEFAULT_COLOR
            }))
            .filter(d => d.value > 0)
            .sort((a, b) => b.value - a.value);

        const total = data.total;

        return (
            <div style={{
                background: "#fff",
                border: "1px solid #ccc",
                padding: "10px",
                borderRadius: "5px"
            }}>
                <p><strong>{label}</strong></p>

                {deptData.map((d, i) => (
                    <p key={i} style={{ margin: 0, color: d.color }}>
                        {d.name} : {d.value}
                    </p>
                ))}

                <hr />

                <p style={{ margin: 0 }}>
                    <strong>Total : {total}</strong>
                </p>
            </div>
        );
    };
    return (
        <div style={{ width: "100%", height: 350 }}>
            <h3>Placed Students (Total: {total})</h3>

            <ResponsiveContainer>
                <BarChart data={chartData} margin={{ top: 20, right: 20, left: 0, bottom: 0 }} >

                    <XAxis dataKey="month" />
                    <YAxis />
                    <Tooltip
                        content={<CustomTooltip />}
                        cursor={false}
                    />
                    <Legend />

                    {/* ✅ Stacked Bars */}
                    {departments.map((dep, index) => {
                        const isLast = index === departments.length - 1;

                        return (
                            <Bar
                                key={dep}
                                dataKey={dep}
                                stackId="a"
                                fill={DEPARTMENT_COLORS[dep] || DEFAULT_COLOR}
                            >
                                {isLast && (
                                    <LabelList
                                        dataKey="total"
                                        content={(props) => {
                                            const { x, y, width, value } = props;

                                            if (!value) return null;

                                            return (
                                                <text
                                                    x={x + width / 2}
                                                    y={y - 4}   // 🔥 perfect spacing
                                                    textAnchor="middle"
                                                    fontSize={12}
                                                    fill="#000"
                                                >
                                                    {value}
                                                </text>
                                            );
                                        }}
                                    />
                                )}
                            </Bar>
                        );
                    })}


                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default PlacedChart;